import { APP_INITIALIZER, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { of } from 'rxjs';

import { EcmDashboardRoutes } from '@ecm/dashboard';
import { MaterialSpinnerComponent } from '@ecm/material';
import {
    AuthGuard,
    ChatbotNavigationService,
    DeepLinkGuard,
    EcmRouterRoutes,
    PhygitalGuard,
    RouteType,
} from '@ecm/router';

import { AliasesRoutes, LazyRoutes } from './routes';

/**
 * Base routes for the application
 * These are the core routes that are not part of any feature module
 */
const BASE_ROUTES: Routes = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'accueil',
    },
    {
        path: 'boutique/mobile',
        component: MaterialSpinnerComponent,
        canActivate: [PhygitalGuard],
        data: {
            type: RouteType.VISITOR,
        },
    },
    {
        path: 'link/:code',
        canActivate: [AuthGuard],
        children: [
            {
                path: '',
                component: MaterialSpinnerComponent,
                canActivate: [DeepLinkGuard],
            },
        ],
    },
];

/**
 * 🔥 All application routes merged into a single array
 * IMPORTANT: EcmRouterRoutes MUST be last as it contains the '**' wildcard catch-all route
 */
const APP_ROUTES: Routes = [
    ...BASE_ROUTES,
    ...AliasesRoutes,
    ...LazyRoutes,
    ...EcmDashboardRoutes,
    ...EcmRouterRoutes, // ⚠️ Keep this LAST - contains '**' wildcard for 404
];

@NgModule({
    imports: [
        // ✅ Single forRoot() call with all routes merged
        RouterModule.forRoot(APP_ROUTES, {
            scrollPositionRestoration: 'enabled',
            anchorScrolling: 'enabled',
            onSameUrlNavigation: 'reload',
            scrollOffset: [0, 80],
        }),
    ],
    providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: (chatbotNavigationService: ChatbotNavigationService) => {
                return () => {
                    return of(chatbotNavigationService.initBotmanListener());
                };
            },
            deps: [ChatbotNavigationService],
            multi: true,
        },
    ],
    exports: [RouterModule],
})
export class DefaultRoutingModule {}
